import rest from "@/utils/rest";
export default {
  GetServicableLimitList: (carWashId) => {
    let link = `ClientService/Limit/${carWashId}`;
    return rest
      .channel(link, {
        method: "GET",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  CheckCar: (CarRegistrationNumber, ServiceId) => {
    let formData1 = {
      CarRegistrationNumber,
      ServiceId,
    };
    let link = "ClientService/CheckCarRegistrationNumber";
    return rest
      .channel(link, {
        body: JSON.stringify(formData1),
        method: "POST",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
  AprooveWachingCode: (policyID, otpCode) => {
    let formData1 = {
      policyID: policyID,
      otp: otpCode,
    };
    let link = "ClientService/AprooveWachingCode";
    return rest
      .channel(link, {
        body: JSON.stringify(formData1),
        method: "POST",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
};
